import {AppDispatch} from '@/store';
import {setShouldPlay} from '@/store/feed/slice';

export const pause = () => (dispatch: AppDispatch) => {
  dispatch(setShouldPlay(false));
};
